import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/varano-construction/varano-construction/components/ConfigImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/varano-construction/varano-construction/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/varano-construction/varano-construction/node_modules/next/dist/client/app-dir/link.js");
